import { createFileRoute } from '@tanstack/react-router'

import CreatePenyuluhPage from '@/components/pages/backoffice/_klb-penyuluh/_desa/containers/CreatePage'

export const Route = createFileRoute('/_backoffice/klb-penyuluh/desa/create')({
  component: CreatePenyuluhPage
})
